"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vobbia": {
    "fd8b9e86": [{
      "hkey": "8f193612",
      "slug": "caprieto-casareggio-salata",
      "name": "Caprieto-Casareggio-Salata",
      "primary": true,
      "skipSearch": false
    }],
    "salata": [{
      "hkey": "8f193612",
      "slug": "caprieto-casareggio-salata",
      "name": "Caprieto-Casareggio-Salata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "87ee39ea": [{
      "hkey": "36e45641",
      "slug": "vallenzona-costa",
      "name": "Vallenzona-Costa",
      "primary": true,
      "skipSearch": false
    }],
    "vallenzona": [{
      "hkey": "36e45641",
      "slug": "vallenzona-costa",
      "name": "Vallenzona-Costa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;